module.exports = {"id":"189272","name":"Alexander Esswein","rating":"73","photo":"./data/images/photos/3/189272.png","club":{"name":"Hertha Berlin","logo":"./data/images/clubs/HerthaBerlin.png"},"positions":["MD","MG","BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexanderEsswein0.json
// module id = 227
// module chunks = 0